import { BaseZenputCollection, BaseZenputModel } from '../../../../backbone-unorganized/shared/forms';
import { MobileBaseField } from '../BaseField/models';
import { ReadingMethod } from '../constants';
import { showErrorMessage } from '../../../../shared/utils/notifications';

export const SensorTemperature = BaseZenputModel.extend({
    defaults: {
        id: null,
        name: null,
        placement: null,
        timestamp: null,
        value: null,
        is_submitted_value: false,
        reading_method: ReadingMethod.SENSOR
    },

    is_dependent_field: function () {
        return false;
    }
});

export const SensorTemperatures = BaseZenputCollection.extend({
    model: SensorTemperature,

    initialize: function (attrs, options) {
        options = options || {};
        $.extend(this, options);
    },

    set_submitted_values: function (submitted_values) {
        const values = submitted_values.map((value) => ({
            is_online: !!value.value,
            last_reading_date: value.timestamp,
            last_reading_value: value.value,
            is_submitted_value: true,
            ...value
        }));
        this.add(values);
    },

    get_sensors_in_location: function (location_id) {
        this.reset();
        if (!location_id) {
            return;
        }

        if (this.limit_placements) {
            const placements = this.selected_placements.join(',');
            this.url = `/api/v2/sensors/sensors/?account_id=${location_id}&placement_id=${placements}`;
        } else {
            this.url = `/api/v2/sensors/sensors/?account_id=${location_id}`;
        }
        return this.fetch();
    },

    get_sensors_with_equipment_locations: function (equipment_locations, success, error) {
        if (!equipment_locations || equipment_locations.length == 0) {
            success();
        }

        this.url = `/api/v2/sensors/sensors/?equipment_location_id=${equipment_locations.join(',')}`;
        return this.fetch({ success, error, reset: true });
    }
});

export const MobileSensorTemperatureField = MobileBaseField.extend({
    sensor_collection: null, // SensorTemperatureItemList
    location_id: null,
    selected_placements: [],
    limit_placements: false,

    initialize: function (attrs, options) {
        const sensor_temperature_data = this.get_metadata_attribute('sensor_temperature_data');
        if (sensor_temperature_data) {
            this.limit_placements = this.get_metadata_attribute('sensor_temperature_data').limit_placements;
            this.selected_placements = this.get_metadata_attribute('sensor_temperature_data').selected_placements;
        }
        this.sensor_collection = new SensorTemperatures(null, {
            limit_placements: this.limit_placements,
            selected_placements: this.selected_placements,
            form_collection: this.collection // MobileFormStructure
        });
        MobileSensorTemperatureField.__super__.initialize.apply(this, arguments);
    },

    _set_location: async function (location_id) {
        this.location_id = location_id;
        try {
            this.sensor_collection.get_sensors_in_location(location_id);
        } catch (err) {
            showErrorMessage(_t('mobile_message_show_error_message'));
        }
    },

    set_initial_location: function (location_id) {
        this._set_location(location_id);
        this.isValid(true);
    },

    change_location: function (location_id) {
        if (this.location_id === location_id) {
            return;
        }

        this.set('value', []);
        this._set_location(location_id);
    }
});
